/** Wspólne stany elementów klikalnych (hover / focus / active / disabled)
 *  centralizują zachowanie menu, dropdownów, popoverów i list opcji.
 *
 *  Zasady:
 *   • klikalne → `cursor-pointer` + widoczne podświetlenie (`bg-crane-accent`),
 *   • Radix ustawia focus przy najechaniu myszą, ale dokładamy jawny `hover:`,
 *     żeby nie zależeć wyłącznie od zachowania biblioteki,
 *   • `disabled` → brak pointera, brak hovera, `cursor-not-allowed`,
 *   • kolory wyłącznie z tokenów (`accent`, `ring`) — zero hexów.
 *
 *  Token `--crane-surface-accent` jest jaśniejszy niż `--crane-popover` i `--crane-card`
 *  (`packages/crane-ui/tokens.css`), więc podświetlenie pozostaje widoczne w dark theme. */

/** Pozycja menu (Radix: DropdownMenuItem, SelectItem, CommandItem…). */
export const menuItemInteractive =
  "cursor-pointer transition-colors " +
  "hover:bg-crane-accent hover:text-crane-accent-foreground " +
  "focus:bg-crane-accent focus:text-crane-accent-foreground " +
  "data-[highlighted]:bg-crane-accent data-[highlighted]:text-crane-accent-foreground " +
  "active:bg-crane-accent/80 " +
  "data-[disabled]:pointer-events-none data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50";

/** Element klikalny spoza Radiksa (własne listy opcji, wiersze, kafle). */
export const clickableInteractive =
  "cursor-pointer transition-colors " +
  "hover:bg-crane-accent hover:text-crane-accent-foreground " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-crane-ring focus-visible:ring-offset-2 focus-visible:ring-offset-crane-background " +
  "active:bg-crane-accent/80 " +
  "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50";

/** Trigger otwierający menu / select / popover. */
export const triggerInteractive =
  "cursor-pointer transition-colors " + "disabled:cursor-not-allowed disabled:opacity-50 disabled:pointer-events-none";
